var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "xr-create",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: { title: _vm.title, "confirm-button-text": _vm.confirmButtonText },
      on: { close: _vm.close, save: _vm.saveClick },
    },
    [
      _c(
        "create-sections",
        { attrs: { title: "基本信息" } },
        [
          _c(
            "el-form",
            {
              ref: "crmForm",
              staticClass: "wk-form",
              attrs: {
                model: _vm.fieldForm,
                rules: _vm.fieldRules,
                "validate-on-rule-change": false,
                "label-position": "top",
              },
            },
            _vm._l(_vm.fieldList, function (children, index) {
              return _c("wk-form-items", {
                key: index,
                attrs: {
                  "field-from": _vm.fieldForm,
                  "field-list": children,
                  "ignore-fields": _vm.ignoreFields,
                },
                on: { change: _vm.formChange },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ data, index }) {
                        return [
                          data && data.field == "invoice_type"
                            ? _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.formChange(data, index, $event)
                                    },
                                  },
                                  model: {
                                    value: _vm.fieldForm[data.field],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.fieldForm, data.field, $$v)
                                    },
                                    expression: "fieldForm[data.field]",
                                  },
                                },
                                _vm._l(_vm.invoiceTypeOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.name,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          data && data.form_type == "customer"
                            ? _c("crm-relative-cell", {
                                attrs: {
                                  value: _vm.fieldForm[data.field],
                                  disabled: data.disabled,
                                  "relative-type": "customer",
                                },
                                on: {
                                  "value-change": function ($event) {
                                    return _vm.otherChange($event, data)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          data && data.form_type == "contract"
                            ? _c("crm-relative-cell", {
                                attrs: {
                                  value: _vm.fieldForm[data.field],
                                  disabled: data.disabled,
                                  relation: data.relation,
                                  "relative-type": data.form_type,
                                },
                                on: {
                                  "value-change": function ($event) {
                                    return _vm.otherChange($event, data)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "create-sections",
        { attrs: { title: "发票信息" } },
        [
          _c(
            "div",
            { staticStyle: { padding: "10px 20px", "text-align": "right" } },
            [
              _c(
                "el-popover",
                {
                  staticStyle: { padding: "0 !important" },
                  attrs: { placement: "top", width: "700", trigger: "click" },
                  model: {
                    value: _vm.showPopover,
                    callback: function ($$v) {
                      _vm.showPopover = $$v
                    },
                    expression: "showPopover",
                  },
                },
                [
                  _vm.showSelectView
                    ? _c("crm-relative", {
                        ref: "crmrelative",
                        attrs: {
                          show: _vm.showPopover,
                          action: _vm.titleAction,
                          radio: "",
                          "crm-type": "invoice_title",
                        },
                        on: {
                          close: function ($event) {
                            _vm.showPopover = false
                          },
                          changeCheckout: _vm.titleSelectChange,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        slot: "reference",
                        disabled: !(
                          _vm.fieldForm.customer_id &&
                          _vm.fieldForm.customer_id.length > 0
                        ),
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          _vm.showSelectView = true
                        },
                      },
                      slot: "reference",
                    },
                    [_vm._v("选择发票信息")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "otherFrom",
              attrs: {
                model: _vm.otherFrom,
                rules: _vm.otherRules,
                "label-position": "top",
              },
            },
            _vm._l(_vm.otherFields, function (item, index) {
              return _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !item.hidden,
                      expression: "!item.hidden",
                    },
                  ],
                  key: item.key,
                  attrs: { prop: item.field },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("\n          " + _vm._s(item.name) + "\n          "),
                    _c("span", { staticStyle: { color: "#999" } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(item.tips || "") +
                          "\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(_vm._f("typeToComponent")(item.form_type), {
                    tag: "component",
                    attrs: {
                      value: _vm.otherFrom[item.field],
                      index: index,
                      item: item,
                      "relative-type": item.form_type,
                      disabled: item.disabled,
                      clearable: false,
                    },
                    on: { "value-change": _vm.otherFieldValueChange },
                  }),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "create-sections",
        { attrs: { title: "邮寄信息" } },
        [
          _c(
            "el-form",
            {
              ref: "mailFrom",
              attrs: {
                model: _vm.mailFrom,
                rules: _vm.mailRules,
                "label-position": "top",
              },
            },
            _vm._l(_vm.mailFields, function (item, index) {
              return _c(
                "el-form-item",
                { key: item.key, attrs: { prop: item.field } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("\n          " + _vm._s(item.name) + "\n          "),
                    _c("span", { staticStyle: { color: "#999" } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(item.tips || "") +
                          "\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(_vm._f("typeToComponent")(item.form_type), {
                    tag: "component",
                    attrs: {
                      value: _vm.mailFrom[item.field],
                      index: index,
                      item: item,
                      "relative-type": item.form_type,
                      disabled: item.disabled,
                      clearable: false,
                    },
                    on: { "value-change": _vm.mailFieldValueChange },
                  }),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isOpenExamine
        ? _c(
            "create-sections",
            { attrs: { title: "审核信息" } },
            [
              _vm.examineInfo.config === 0 || _vm.examineInfo.config === 1
                ? _c(
                    "div",
                    {
                      staticClass: "examine-type",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.examineInfo.config === 1
                            ? "固定审批流"
                            : "授权审批人"
                        )
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("create-examine-info", {
                ref: "examineInfo",
                attrs: { "types-id": _vm.editId, types: "crm_invoice" },
                on: { "value-change": _vm.examineValueChange },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }